// Étape 14 — Missions : liste (consultant / admin), fiche mission, livrables à relire, chronologie
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, Input, Select, FormField, Alert, Spinner } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("auprea_token")}` } });
const fd = (iso) => iso ? new Date(iso).toLocaleDateString("fr-FR") : "—";
const fdt = (iso) => iso ? new Date(iso).toLocaleString("fr-FR", { dateStyle: "short", timeStyle: "short" }) : "";
const box = { background: "#fff", border: `.5px solid ${C.border}`, borderRadius: 12, padding: 16, marginBottom: 14 };
const h = { fontSize: 13, fontWeight: 700, color: C.navy, marginBottom: 10, fontFamily: "'Playfair Display', serif" };
const err = (e) => alert(e?.response?.data?.detail || "Erreur");

export const Chronologie = ({ pid }) => {
  const [ev, setEv] = useState(null);
  useEffect(() => { axios.get(`${API}/parcours/${pid}/chronologie`, hdr()).then(r => setEv(r.data)).catch(() => setEv([])); }, [pid]);
  if (!ev) return null;
  return (
    <div style={box} data-testid="chronologie">
      <div style={h}>Chronologie du dossier</div>
      {ev.length === 0 && <div style={{ fontSize: 12, color: C.muted }}>Aucun événement.</div>}
      {ev.map((e, i) => (
        <div key={i} style={{ display: "flex", gap: 10, fontSize: 12, padding: "4px 0", borderLeft: `2px solid ${C.gold}`, paddingLeft: 10, marginLeft: 4 }} data-testid={`chrono-${e.type}`}>
          <span style={{ color: C.muted, minWidth: 110 }}>{fdt(e.at)}</span><span style={{ color: C.navy }}>{e.label}</span>
        </div>
      ))}
    </div>
  );
};

const Etape = ({ m, e, reload }) => {
  const [com, setCom] = useState(e.commentaire || "");
  const [date, setDate] = useState(new Date().toISOString().slice(0, 10));
  const go = (fait) => axios.post(`${API}/missions/${m.id}/etapes/${e.id}`, { fait, date, commentaire: com }, hdr()).then(r => reload(r.data)).catch(err);
  return (
    <div style={{ display: "flex", alignItems: "center", gap: 8, padding: "6px 0", borderTop: `.5px solid ${C.border}`, fontSize: 12 }} data-testid={`etape-${e.id}`}>
      <input type="checkbox" checked={e.fait} disabled={m.statut !== "en_cours" || (e.bloquee && !e.fait)} onChange={(x) => go(x.target.checked)} data-testid={`etape-check-${e.id}`} />
      <span style={{ flex: 1, color: e.fait ? C.green : C.navy }}>{e.libelle}{e.fait ? ` — le ${fd(e.fait_at)}` : ""}{e.bloquee && !e.fait ? " 🔒" : ""}</span>
      {!e.fait && <Input type="date" value={date} onChange={(x) => setDate(x.target.value)} style={{ width: 140 }} />}
      <Input value={com} onChange={(x) => setCom(x.target.value)} placeholder="Commentaire" style={{ width: 200 }} data-testid={`etape-com-${e.id}`} />
    </div>
  );
};

const Rdv = ({ m, reload }) => {
  const [f, setF] = useState({ date: "", heure: "10:00", format: "visio", lieu: "", objet: "Rendez-vous" });
  const set = (k) => (x) => setF({ ...f, [k]: x.target.value });
  const go = () => axios.post(`${API}/missions/${m.id}/rdv`, f, hdr()).then(r => { reload(r.data); setF({ ...f, date: "", lieu: "" }); }).catch(err);
  return (
    <div style={box} data-testid="mission-rdv">
      <div style={h}>Rendez-vous</div>
      {m.rdvs.map(r => <div key={r.id} style={{ fontSize: 12, marginBottom: 4 }}>• {r.objet} — {fd(r.at)} à {r.heure} · {r.format === "visio" ? "visio" : "présentiel"} · {r.lieu} {r.rappel_envoye ? "(rappel envoyé)" : ""}</div>)}
      <div style={{ display: "grid", gridTemplateColumns: "1.2fr 1fr .8fr 1fr 2fr auto", gap: 8, alignItems: "end", marginTop: 8 }}>
        <FormField label="Objet"><Input value={f.objet} onChange={set("objet")} data-testid="rdv-objet" /></FormField>
        <FormField label="Date"><Input type="date" value={f.date} onChange={set("date")} data-testid="rdv-date" /></FormField>
        <FormField label="Heure"><Input type="time" value={f.heure} onChange={set("heure")} data-testid="rdv-heure" /></FormField>
        <FormField label="Format"><Select value={f.format} onChange={set("format")} data-testid="rdv-format"><option value="visio">Visio</option><option value="presentiel">Présentiel</option></Select></FormField>
        <FormField label={f.format === "visio" ? "Lien" : "Lieu"}><Input value={f.lieu} onChange={set("lieu")} data-testid="rdv-lieu" /></FormField>
        <Btn variant="gold" disabled={!f.date || !f.lieu} onClick={go} data-testid="rdv-enregistrer">Enregistrer et confirmer</Btn>
      </div>
    </div>
  );
};

const Documents = ({ m, reload }) => {
  const coche = (d) => axios.post(`${API}/missions/${m.id}/documents/${d.id}`, { recu: !d.recu }, hdr()).then(r => reload(r.data)).catch(err);
  const complets = () => window.confirm("Déclarer les documents complets ?") && axios.post(`${API}/missions/${m.id}/documents-complets`, {}, hdr()).then(r => reload(r.data)).catch(err);
  const rubs = [...new Set(m.documents.map(d => d.rubrique))];
  return (
    <div style={box} data-testid="mission-documents">
      <div style={{ ...h, display: "flex", justifyContent: "space-between" }}>
        <span>Documents à fournir ({m.documents.filter(d => d.recu).length}/{m.documents.length})</span>
        {m.documents_complets_at ? <span style={{ color: C.green, fontSize: 12 }} data-testid="docs-complets-ok">Complets le {fd(m.documents_complets_at)}{m.echeance_livrables_at ? ` · livrables attendus le ${fd(m.echeance_livrables_at)}` : ""}</span>
          : <Btn small variant="teal" onClick={complets} data-testid="docs-complets-btn">Documents complets</Btn>}
      </div>
      {rubs.map(r => <div key={r} style={{ marginBottom: 6 }}><div style={{ fontSize: 11, fontWeight: 700, color: C.mid, textTransform: "uppercase" }}>{r}</div>
        {m.documents.filter(d => d.rubrique === r).map(d => <label key={d.id} style={{ display: "flex", gap: 8, fontSize: 12, padding: "2px 0" }}>
          <input type="checkbox" checked={d.recu} onChange={() => coche(d)} data-testid={`doc-${d.id}`} />{d.libelle}</label>)}</div>)}
    </div>
  );
};

const Livrables = ({ m, reload }) => {
  const [nom, setNom] = useState("");
  const [file, setFile] = useState(null);
  const [groupe, setGroupe] = useState(m.groupes[0]?.code || "");
  const [busy, setBusy] = useState(false);
  const up = async () => {
    const fdata = new FormData(); fdata.append("nom", nom); fdata.append("groupe", groupe); fdata.append("file", file);
    setBusy(true);
    try { const r = await axios.post(`${API}/missions/${m.id}/livrables`, fdata, hdr()); reload(r.data); setNom(""); setFile(null); } catch (e) { err(e); }
    setBusy(false);
  };
  const envoyer = async (l) => {
    if (!window.confirm(`Envoyer « ${l.nom} » au client ?`)) return;
    try { const r = await axios.post(`${API}/missions/${m.id}/livrables/${l.id}/envoyer`, {}, hdr()); alert(r.data.statut === "a_relire" ? "Livrable transmis à l'admin pour relecture." : "Livrable envoyé au client."); reload(); } catch (e) { err(e); }
  };
  const voir = async (l) => { const r = await axios.get(`${API}/missions/${m.id}/livrables/${l.id}`, { ...hdr(), responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); };
  const ST = { brouillon: "Prêt à envoyer", a_relire: "En relecture admin", refuse: "Refusé — à reprendre", envoye: "Envoyé" };
  return (
    <div style={box} data-testid="mission-livrables">
      <div style={h}>Livrables</div>
      {m.livrables.map(l => (
        <div key={l.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, padding: "5px 0", borderTop: `.5px solid ${C.border}` }} data-testid={`livrable-${l.id}`}>
          <span style={{ flex: 1 }}>{l.nom} {l.relecture_obligatoire ? "· relecture obligatoire" : ""}{l.commentaire_admin ? ` — admin : ${l.commentaire_admin}` : ""}</span>
          <span style={{ fontWeight: 700, color: l.statut === "envoye" ? C.green : l.statut === "refuse" ? C.red : C.amber }}>{ST[l.statut]}{l.envoye_at ? ` le ${fd(l.envoye_at)}` : ""}</span>
          <Btn small onClick={() => voir(l)}>PDF</Btn>
          {["brouillon", "refuse"].includes(l.statut) && <Btn small variant="gold" onClick={() => envoyer(l)} data-testid={`livrable-envoyer-${l.id}`}>Envoyer au client</Btn>}
        </div>))}
      {m.avis.map((a, i) => <div key={i} style={{ fontSize: 12, color: C.teal, marginTop: 6 }} data-testid="mission-avis">★ {a.note}/5 {a.commentaire ? `— « ${a.commentaire} »` : ""}</div>)}
      <div style={{ display: "grid", gridTemplateColumns: "2fr 1fr 2fr auto", gap: 8, alignItems: "end", marginTop: 10 }}>
        <FormField label="Nom du livrable"><Input value={nom} onChange={(e) => setNom(e.target.value)} placeholder="Rapport, dossier de continuité…" data-testid="livrable-nom" /></FormField>
        <FormField label="Prestation"><Select value={groupe} onChange={(e) => setGroupe(e.target.value)}>{m.groupes.map(g => <option key={g.code} value={g.code}>{g.titre}</option>)}</Select></FormField>
        <FormField label="Fichier PDF"><input type="file" accept="application/pdf" onChange={(e) => setFile(e.target.files[0])} data-testid="livrable-file" /></FormField>
        <Btn variant="teal" disabled={!nom || !file || busy} onClick={up} data-testid="livrable-televerser">{busy ? "Envoi…" : "Téléverser"}</Btn>
      </div>
    </div>
  );
};

export const MissionDetail = ({ mid, onBack }) => {
  const [m, setM] = useState(null);
  const load = (data) => data ? setM(data) : axios.get(`${API}/missions/${mid}`, hdr()).then(r => setM(r.data));
  useEffect(() => { load(); }, [mid]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!m) return <Spinner />;
  const preparer = () => axios.post(`${API}/missions/${m.id}/suivi-annuel/preparer`, {}, hdr()).then(() => alert("Nouvelle proposition de suivi annuel préremplie : ouvrez le dossier pour la vérifier et l'envoyer.")).catch(err);
  return (
    <div data-testid="mission-detail">
      {onBack && <Btn small onClick={onBack} data-testid="mission-retour">← Retour aux missions</Btn>}
      <div style={{ display: "flex", alignItems: "center", gap: 10, margin: "12px 0" }}>
        <div style={{ fontSize: 18, fontWeight: 700, color: C.navy, fontFamily: "'Playfair Display', serif" }}>{m.client.prenom} {m.client.nom} — proposition N°{m.proposition_numero}</div>
        <span data-testid="mission-statut" style={{ fontSize: 11, fontWeight: 700, color: m.statut === "terminee" ? C.green : C.navy, border: `.5px solid`, borderRadius: 20, padding: "2px 10px" }}>{m.statut === "terminee" ? "Mission terminée" : "Mission en cours"}</span>
        {m.retard && <span data-testid="mission-retard" style={{ fontSize: 11, fontWeight: 700, color: "#fff", background: C.red, borderRadius: 20, padding: "2px 10px" }}>En retard</span>}
      </div>
      {m.demarrage_possible_at && new Date(m.demarrage_possible_at) > new Date() && <Alert type="warn"><span>⏳</span><span data-testid="mission-demarrage">Démarrage possible le {fd(m.demarrage_possible_at)} (délai de rétractation) : seule la prise de rendez-vous peut être validée avant.</span></Alert>}
      {m.statut === "terminee" && <Btn small variant="gold" onClick={preparer} data-testid="mission-suivi-annuel">Préparer la proposition de suivi annuel</Btn>}
      {m.groupes.map(g => (
        <div key={g.code} style={box} data-testid={`groupe-${g.code}`}>
          <div style={h}>{g.titre}</div>
          {g.etapes.map(e => <Etape key={e.id} m={m} e={e} reload={load} />)}
        </div>))}
      <Rdv m={m} reload={load} />
      <Documents m={m} reload={load} />
      <Livrables m={m} reload={load} />
      <Chronologie pid={m.parcoursId} key={JSON.stringify(m.journal?.length)} />
    </div>
  );
};

export const LivrablesARelire = () => {
  const [rows, setRows] = useState(null);
  const load = () => axios.get(`${API}/admin/livrables/a-relire`, hdr()).then(r => setRows(r.data));
  useEffect(() => { load(); }, []);
  const voir = async (x) => { const r = await axios.get(`${API}/missions/${x.mission_id}/livrables/${x.id}`, { ...hdr(), responseType: "blob" }); window.open(URL.createObjectURL(r.data), "_blank"); };
  const decider = (x, decision) => {
    const commentaire = decision === "refuser" ? window.prompt("Motif du refus (transmis au consultant) :") : "";
    if (decision === "refuser" && !commentaire) return;
    axios.post(`${API}/admin/livrables/${x.mission_id}/${x.id}`, { decision, commentaire }, hdr()).then(load).catch(err);
  };
  if (!rows) return <Spinner />;
  return (
    <div style={box} data-testid="livrables-a-relire">
      <div style={h}>Livrables à relire ({rows.length})</div>
      {rows.length === 0 && <div style={{ fontSize: 12, color: C.muted }} data-testid="relire-vide">Aucun livrable en attente de relecture.</div>}
      {rows.map(x => (
        <div key={x.id} style={{ display: "flex", gap: 8, alignItems: "center", fontSize: 12, padding: "6px 0", borderTop: `.5px solid ${C.border}` }} data-testid={`relire-${x.id}`}>
          <span style={{ flex: 1 }}><strong>{x.nom}</strong> — {x.client.prenom} {x.client.nom} (N°{x.proposition_numero}) · soumis le {fd(x.soumis_at)} par {x.par}</span>
          <Btn small onClick={() => voir(x)}>Lire le PDF</Btn>
          <Btn small variant="teal" onClick={() => decider(x, "valider")} data-testid={`relire-valider-${x.id}`}>Valider et envoyer</Btn>
          <Btn small variant="red" onClick={() => decider(x, "refuser")} data-testid={`relire-refuser-${x.id}`}>Refuser</Btn>
        </div>))}
    </div>
  );
};

export default function MissionsPage({ isAdmin }) {
  const [rows, setRows] = useState(null);
  const [open, setOpen] = useState(null);
  useEffect(() => { if (!open) axios.get(`${API}/missions`, hdr()).then(r => setRows(r.data)); }, [open]);
  if (open) return <MissionDetail mid={open} onBack={() => setOpen(null)} />;
  if (!rows) return <Spinner />;
  const th = { textAlign: "left", padding: "9px 12px", fontSize: 10, color: C.muted, textTransform: "uppercase", fontWeight: 700 };
  const td = { padding: "9px 12px", fontSize: 12, color: C.mid, borderTop: `.5px solid ${C.border}` };
  return (
    <div data-testid="missions-page">
      {isAdmin && <LivrablesARelire />}
      <div style={{ fontSize: 12, color: C.mid, marginBottom: 8 }} data-testid="missions-compteurs">{rows.filter(x => x.statut === "en_cours").length} en cours · <span style={{ color: C.red }}>{rows.filter(x => x.retard).length} en retard</span> · {rows.filter(x => x.statut === "terminee").length} terminée(s)</div>
      <div style={{ ...box, padding: 0, overflow: "hidden" }}><table style={{ width: "100%", borderCollapse: "collapse" }}>
        <thead><tr style={{ background: C.gray2 }}>{["Client", "Prestations", "Avancement", "Prochain RDV", "Échéance livrables", "Statut", ""].map(x => <th key={x} style={th}>{x}</th>)}</tr></thead>
        <tbody>{rows.map(x => (
          <tr key={x.id} data-testid={`mission-row-${x.id}`}>
            <td style={{ ...td, color: C.navy, fontWeight: 700 }}>{x.client.prenom} {x.client.nom}<div style={{ fontWeight: 400, fontSize: 11, color: C.muted }}>N°{x.proposition_numero}</div></td>
            <td style={td}>{x.titres.join(", ")}</td><td style={td}>{x.faites}/{x.total}</td>
            <td style={td}>{x.prochain_rdv ? `${fd(x.prochain_rdv.at)} ${x.prochain_rdv.heure}` : "—"}</td><td style={td}>{fd(x.echeance_livrables_at)}</td>
            <td style={td}>{x.retard ? <span style={{ background: C.red, color: "#fff", borderRadius: 10, padding: "2px 8px", fontWeight: 700 }} data-testid={`mission-retard-${x.id}`}>En retard</span> : x.statut === "terminee" ? "Terminée" : "En cours"}{x.a_relire ? " · à relire" : ""}</td>
            <td style={{ ...td, textAlign: "right" }}><Btn small onClick={() => setOpen(x.id)} data-testid={`mission-ouvrir-${x.id}`}>Ouvrir</Btn></td>
          </tr>))}
          {rows.length === 0 && <tr><td colSpan={7} style={{ ...td, textAlign: "center", padding: 30 }}>Aucune mission. Les missions sont créées automatiquement au paiement.</td></tr>}
        </tbody></table></div>
    </div>
  );
}
